<template>
  <section class="result-lesson" v-show="lessons.length">
    <h2 class="mb-3">{{ lessonTerm | capitalize }} slides</h2>
    <result-lesson-card
      v-for="(lesson, index) in lessons"
      :key="'ls-' + index"
      :studentLessons="lesson"
    />
  </section>
</template>
<script>
import ResultLessonCard from './ResultLessonCard'
import { mapState } from 'vuex'

export default {
  name: 'ResultLesson',
  components: {
    ResultLessonCard
  },
  props: {
    studentLessons: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState(['lessonTerm']),
    lessons() {
      const res = this.studentLessons.reduce((acc, curr) => {
        if (!acc[curr.lesson_id]) acc[curr.lesson_id] = [] //If this type wasn't previously stored
        acc[curr.lesson_id].push(curr)
        return acc
      }, {})
      const lessonGroup = Object.keys(res).map(i => res[i])

      if (!lessonGroup) return []

      return lessonGroup
    }
  },
  async mounted() {}
}
</script>

<style lang="scss" scoped>
.result-lesson {
  overflow: hidden;
  .ov {
    span {
      display: block;
    }
  }
}
</style>
